module.exports = __webpack_public_path__ + "img/94.f1c1a1d0.png";